// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27 style=%27fill: rgba%280, 0, 0, 0.5%29%27%3E%3Cpath d=%27M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* Placeholder styles
*/
.tiptap p.is-empty:not(.is-editor-empty) {
  height: 2lh;

  @screen sm {
    height: auto;
  }
}

.tiptap p.is-empty::before {
  color: #adb5bd;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}

/*
* Task list styles
*/
.tiptap li::marker {
  color: #374151;
}

.tiptap ul[data-type="taskList"] {
  list-style: none;
  margin-left: 0;
  padding: 0;
}

.tiptap ul[data-type="taskList"] li {
  align-items: flex-start;
  display: flex;
}

.tiptap ul[data-type="taskList"] li > label {
  flex: 0 0 auto;
  margin-right: 0.5rem;
  user-select: none;
}

.tiptap ul[data-type="taskList"] li > div {
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
}

.tiptap ul[data-type="taskList"] li > div > p {
  margin-top: 0;
}

.tiptap ul[data-type="taskList"] input[type="checkbox"] {
  cursor: pointer;
  vertical-align: middle;
  border-radius: 0.375rem;
  border: 1px solid #6b7280;
  width: 1.125rem;
  height: 1.125rem;
}

.tiptap ul[data-type="taskList"] input[type="checkbox"]:checked {
  color: #4d7f7c;
  border-color: #406a68;
}

.tiptap ul[data-type="taskList"] input[type="checkbox"]:checked:hover {
  color: #406a68;
}

.tiptap ul[data-type="taskList"] input[type="checkbox"]:not(:checked):hover {
  background-color: #f9f9fb;
}

.tiptap ul[data-type="taskList"] li[data-checked="true"] p:not(:has(.mention)) {
  text-decoration: line-through;
}

.tiptap ul[data-type="taskList"] ul[data-type="taskList"] {
  margin: 0;
}

/*
* Caret styles
*/
/* Give a remote user a caret */
.collaboration-cursor__caret {
  border-left: 1px solid #0d0d0d;
  border-right: 1px solid #0d0d0d;
  margin-left: -1px;
  margin-right: -1px;
  pointer-events: none;
  position: relative;
  word-break: normal;
}

/* Render the username above the caret */
.collaboration-cursor__label {
  border-radius: 3px 3px 3px 0;
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  left: -1px;
  line-height: normal;
  padding: 0.1rem 0.3rem;
  position: absolute;
  top: -1.4em;
  user-select: none;
  white-space: nowrap;
}

/* Render the drag handler */
.drag-handle {
  position: fixed;
  opacity: 1;
  transition: opacity ease-in 0.2s;
  border-radius: 0.25rem;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: calc(0.5em + 0.375rem) calc(0.5em + 0.375rem);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.2rem;
  height: 1.5rem;
  z-index: 50;
  cursor: grab;
  transform: translate(-0.5em, -0.5em);

  &.hide {
    opacity: 0;
    pointer-events: none;
  }
}

.free-text-form .drag-handle {
  transform: translate(0, 0);
}

#editor-compact .drag-handle,
#editor-mobile .drag-handle {
  display: none;
}

/* Gapcursor */
.ProseMirror-gapcursor {
  border-color: #406a68;
  border-top-width: 2px;
}

/* Mention */
.mention::before,
.mention::after {
  content: "\\200B";
}

/* Document */
.node-document.ProseMirror-selectednode {
  outline: 2px solid #c6ddf8;
  outline-offset: 2px;
  border-radius: 8px;
}

/*
* Dark theme styles
*/
.dark .tiptap,
.dark .tiptap a,
.dark .tiptap b,
.dark .tiptap strong,
.dark .tiptap h1,
.dark .tiptap h2,
.dark .tiptap h3,
.dark .tiptap ul li,
.dark .tiptap ol li,
.dark .tiptap ul li::marker,
.dark .tiptap ol li::marker {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/tiptap.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,WAAW;;EAEX;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;;CAEC;AACD;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;;CAEC;AACD,+BAA+B;AAC/B;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,UAAU;EACV,gCAAgC;EAChC,sBAAsB;;EAEtB,yDAA08B;EAC18B,8DAA8D;EAC9D,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;;EAEpC;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;;EAEE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;;;;;;;;;;EAWE,YAAY;AACd","sourcesContent":["/*\n* Placeholder styles\n*/\n.tiptap p.is-empty:not(.is-editor-empty) {\n  height: 2lh;\n\n  @screen sm {\n    height: auto;\n  }\n}\n\n.tiptap p.is-empty::before {\n  color: #adb5bd;\n  content: attr(data-placeholder);\n  float: left;\n  height: 0;\n  pointer-events: none;\n}\n\n/*\n* Task list styles\n*/\n.tiptap li::marker {\n  color: #374151;\n}\n\n.tiptap ul[data-type=\"taskList\"] {\n  list-style: none;\n  margin-left: 0;\n  padding: 0;\n}\n\n.tiptap ul[data-type=\"taskList\"] li {\n  align-items: flex-start;\n  display: flex;\n}\n\n.tiptap ul[data-type=\"taskList\"] li > label {\n  flex: 0 0 auto;\n  margin-right: 0.5rem;\n  user-select: none;\n}\n\n.tiptap ul[data-type=\"taskList\"] li > div {\n  flex: 1 1 auto;\n  min-width: 0;\n  word-break: break-word;\n}\n\n.tiptap ul[data-type=\"taskList\"] li > div > p {\n  margin-top: 0;\n}\n\n.tiptap ul[data-type=\"taskList\"] input[type=\"checkbox\"] {\n  cursor: pointer;\n  vertical-align: middle;\n  border-radius: 0.375rem;\n  border: 1px solid #6b7280;\n  width: 1.125rem;\n  height: 1.125rem;\n}\n\n.tiptap ul[data-type=\"taskList\"] input[type=\"checkbox\"]:checked {\n  color: #4d7f7c;\n  border-color: #406a68;\n}\n\n.tiptap ul[data-type=\"taskList\"] input[type=\"checkbox\"]:checked:hover {\n  color: #406a68;\n}\n\n.tiptap ul[data-type=\"taskList\"] input[type=\"checkbox\"]:not(:checked):hover {\n  background-color: #f9f9fb;\n}\n\n.tiptap ul[data-type=\"taskList\"] li[data-checked=\"true\"] p:not(:has(.mention)) {\n  text-decoration: line-through;\n}\n\n.tiptap ul[data-type=\"taskList\"] ul[data-type=\"taskList\"] {\n  margin: 0;\n}\n\n/*\n* Caret styles\n*/\n/* Give a remote user a caret */\n.collaboration-cursor__caret {\n  border-left: 1px solid #0d0d0d;\n  border-right: 1px solid #0d0d0d;\n  margin-left: -1px;\n  margin-right: -1px;\n  pointer-events: none;\n  position: relative;\n  word-break: normal;\n}\n\n/* Render the username above the caret */\n.collaboration-cursor__label {\n  border-radius: 3px 3px 3px 0;\n  color: #fff;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  left: -1px;\n  line-height: normal;\n  padding: 0.1rem 0.3rem;\n  position: absolute;\n  top: -1.4em;\n  user-select: none;\n  white-space: nowrap;\n}\n\n/* Render the drag handler */\n.drag-handle {\n  position: fixed;\n  opacity: 1;\n  transition: opacity ease-in 0.2s;\n  border-radius: 0.25rem;\n\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10' style='fill: rgba(0, 0, 0, 0.5)'%3E%3Cpath d='M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z'%3E%3C/path%3E%3C/svg%3E\");\n  background-size: calc(0.5em + 0.375rem) calc(0.5em + 0.375rem);\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 1.2rem;\n  height: 1.5rem;\n  z-index: 50;\n  cursor: grab;\n  transform: translate(-0.5em, -0.5em);\n\n  &.hide {\n    opacity: 0;\n    pointer-events: none;\n  }\n}\n\n.free-text-form .drag-handle {\n  transform: translate(0, 0);\n}\n\n#editor-compact .drag-handle,\n#editor-mobile .drag-handle {\n  display: none;\n}\n\n/* Gapcursor */\n.ProseMirror-gapcursor {\n  border-color: #406a68;\n  border-top-width: 2px;\n}\n\n/* Mention */\n.mention::before,\n.mention::after {\n  content: \"\\200B\";\n}\n\n/* Document */\n.node-document.ProseMirror-selectednode {\n  outline: 2px solid #c6ddf8;\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n/*\n* Dark theme styles\n*/\n.dark .tiptap,\n.dark .tiptap a,\n.dark .tiptap b,\n.dark .tiptap strong,\n.dark .tiptap h1,\n.dark .tiptap h2,\n.dark .tiptap h3,\n.dark .tiptap ul li,\n.dark .tiptap ol li,\n.dark .tiptap ul li::marker,\n.dark .tiptap ol li::marker {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
